package org.example.willfreightnew.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.example.willfreightnew.HeadlineTextStyle
import org.example.willfreightnew.components.layouts.PageLayoutData
import org.jetbrains.compose.web.dom.Div
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.px
import org.example.willfreightnew.components.util.Constants.SECTION_WIDTH
import org.example.willfreightnew.components.models.Section
import org.example.willfreightnew.components.models.Service
import org.example.willfreightnew.components.ServiceCard
import org.example.willfreightnew.components.SectionTitle
import org.example.willfreightnew.pages.HeroContainerStyle
import org.example.willfreightnew.toSitePalette
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.percent

@InitRoute
fun initServicesPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Services"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun ServiceSection() {
    Box(HeroContainerStyle.toModifier()) {
        Div(HeadlineTextStyle.toAttrs()) {
            Box(
                modifier = Modifier
                    .id(Section.Services.id)
                    .maxWidth(SECTION_WIDTH.px)
                    .padding(top = 20.px, bottom = 100.px)
                    .backgroundColor(ColorMode.current.toSitePalette().background),
                contentAlignment = Alignment.Center
            ) {
                ServiceContent()
            }
        }
    }
}

@Composable
fun ServiceContent() {
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = 40.px)
                .textAlign(TextAlign.Center),
            section = Section.Services,
            alignment = Alignment.CenterHorizontally
        )
        SimpleGrid(numColumns = numColumns(1, 1, 2, 3)) {
            Service.entries.forEach { service ->
                ServiceCard(service = service)
            }
        }
    }
}